import intercept from 'notebook/tables/excess/functions/intercept';
import isnumber from 'notebook/tables/excess/functions/isnumber';
import rsq from 'notebook/tables/excess/functions/rsq';
import slope from 'notebook/tables/excess/functions/slope';

import {SpreadsheetFunction} from './FunctionConstants';
import abs from './functions/abs';
import and from './functions/and';
import average from './functions/average';
import ceiling from './functions/ceiling';
import concatenate from './functions/concatenate';
import count from './functions/count';
import days from './functions/days';
import exp from './functions/exp';
import fact from './functions/fact';
import false_ from './functions/false';
import floor from './functions/floor';
import if_ from './functions/if';
import iferror from './functions/iferror';
import isblank from './functions/isblank';
import iserror from './functions/iserror';
import left from './functions/left';
import len from './functions/len';
import ln from './functions/ln';
import log from './functions/log';
import lookup from './functions/lookup';
import lookupField from './functions/lookupField';
import lower from './functions/lower';
import max from './functions/max';
import median from './functions/median';
import mid from './functions/mid';
import min from './functions/min';
import mod from './functions/mod';
import not from './functions/not';
import or from './functions/or';
import pi from './functions/pi';
import power from './functions/power';
import product from './functions/product';
import reverseComplement from './functions/reverseComplement';
import right from './functions/right';
import round from './functions/round';
import search from './functions/search';
import sqrt from './functions/sqrt';
import stdev from './functions/stdev';
import substitute from './functions/substitute';
import sum from './functions/sum';
import textjoin from './functions/textjoin';
import true_ from './functions/true';
import upper from './functions/upper';
import xlookup from './functions/xlookup';

export const functions: Array<SpreadsheetFunction> = [
  abs,
  and,
  average,
  ceiling,
  concatenate,
  count,
  days,
  exp,
  fact,
  false_,
  floor,
  if_,
  iferror,
  intercept,
  isblank,
  iserror,
  isnumber,
  left,
  len,
  ln,
  log,
  lower,
  lookup,
  lookupField,
  max,
  median,
  mid,
  min,
  mod,
  not,
  or,
  pi,
  power,
  product,
  reverseComplement,
  right,
  round,
  rsq,
  slope,
  sqrt,
  stdev,
  substitute,
  sum,
  textjoin,
  true_,
  upper,
  xlookup,
  search,
];

export const getFunction = (want: string): SpreadsheetFunction | undefined =>
  functions.filter(({name}) => name === want)[0];

/**
 * Excludes any functions that do not have a SpreadsheetFunction.category, as we don't have a clean way of
 * determining if those functions are available for use within a given table. While we could refactor the
 * components such that TableEditable.props.additionalFunctions is threaded into FormulaEditable, as of
 * 2023-05-01, LOOKUPFIELD is the only such function, and it is only available in legacy tables used in
 * Legacy Workflows.
 */
export function findFunctions(prefix: string): Array<SpreadsheetFunction> {
  const lowerPrefix = prefix.toLowerCase();
  return (
    functions
      // The number of functions being searched over is small enough (~30) that the performance hit from
      // calling toLowerCase repeatedly is negligible.
      .filter(
        ({name, relatedNames}) =>
          name.toLowerCase().startsWith(lowerPrefix) ||
          relatedNames?.some((relatedName) => relatedName.toLowerCase().startsWith(lowerPrefix))
      )
      .filter(({category}) => category != null)
  );
}
